import PropTypes from 'prop-types'
import React, { Component } from 'react'

import LearningPathCourse from '../LearningPathCourse'
import './styles.css'

export default class LearningPathCourses extends Component {
  constructor(props) {
    super(props)
    this.state = {
      nextCourses: props.courses.length > 4 ? props.courses.slice(4) : [],
      shownCourses:
        props.courses.length <= 4 ? props.courses : props.courses.slice(0, 4)
    }
    this.showAllCourses = this.showAllCourses.bind(this)
  }

  showAllCourses() {
    this.setState({
      nextCourses: [],
      shownCourses: [...this.state.shownCourses, ...this.state.nextCourses]
    })
  }

  render() {
    const {
      slug,
      pathId,
      setVideoPreview,
      loadLearningPathwayCourse,
      loadBookmarkContext,
      routePath,
      filter,
      isEnrolled,
      isBasicSubscriber
    } = this.props
    const { shownCourses, nextCourses } = this.state

    return (
      <div className="learning-path-courses">
        {shownCourses.map((course) => (
          <LearningPathCourse
            {...Object.assign({ learningPath: slug }, course)}
            key={course.id}
            pathId={pathId}
            openPreview={(tutorial) => setVideoPreview(tutorial)}
            loadLearningPathwayCourse={(bookmark, courseSlug) => {
              loadLearningPathwayCourse.call(
                loadBookmarkContext,
                bookmark,
                courseSlug,
                routePath
              )
            }}
            filter={filter}
            isEnrolled={isEnrolled}
            isBasicSubscriber={isBasicSubscriber}
          />
        ))}
        {nextCourses.length > 0 && (
          <div className="load-more-courses">
            <button
              type="button"
              className="load-more-courses-btn"
              onClick={() => this.showAllCourses()}
            >
              <i className="icon-plus load-more-courses-btn__icon" />
              Load More Courses ({nextCourses.length})
            </button>
          </div>
        )}
      </div>
    )
  }
}

LearningPathCourses.propTypes = {
  courses: PropTypes.arrayOf(PropTypes.object).isRequired,
  filter: PropTypes.arrayOf(PropTypes.any).isRequired,
  loadLearningPathwayCourse: PropTypes.func,
  loadBookmarkContext: PropTypes.shape({
    location: PropTypes.object
  }),
  owned: PropTypes.bool,
  pathId: PropTypes.number,
  routePath: PropTypes.string,
  setVideoPreview: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
  isEnrolled: PropTypes.bool,
  isBasicSubscriber: PropTypes.bool
}

LearningPathCourses.defaultProps = {
  loadBookmark: () => {},
  owned: false,
  loadLearningPathwayCourse: () => {},
  isEnrolled: false,
  isBasicSubscriber: false
}
